<template>
	<core-layout-content full>
		<core-layout-headline-and-actions>
			<template slot="headline">
				{{ $t("binders") }}
				<core-pagination-info
					:itemsPerPage="itemsPerPage"
					:numberOfItems="numberOfItems"
					:currentPage="page"
				/>
			</template>
			<template slot="actions">
				<!-- TODO: handle permissions after backend has it  v-can="'writeBinders'" -->
				<j-button :to="{ name: 'BindersCreate' }" v-can="'writeBinders'">
					<crm-icon name="add" size="small" color="c5" />
					{{ $t("create_binder") }}
				</j-button>
			</template>
		</core-layout-headline-and-actions>

		<!-- Search -->
		<!-- HACK: hiding until we have filter based on facts as binderNumber is in facts -->
		<!-- <div class="flex wrap xs-12 xs-left mb2">
			<div class="flex xs-12">
				<j-base-input-search
					:placeholder="$t('search_name_code')"
					:value="searchTerm"
					@input="onSearch"
				/>
				<j-button
					class="ml2"
					type="tertiary"
					v-if="searchTerm"
					@click="cancelSearch"
					>{{ $t("cancel") }}</j-button
				>
			</div>
		</div> -->

		<!-- Data Container -->
		<j-card class="bg5">
			<j-data-table
				:header="header"
				:list="binders_"
				:sortable="false"
				:isLoading="isLoading"
				@sort="onSort($event)"
			>
				<template slot="list" slot-scope="{ item }">
					<td v-for="(column, i) in header" :key="i">
						<template>
							<!-- Name -->
							<template v-if="column.field === 'binderNumber'">
								<router-link
									:to="{
										name: `BindersUpdate`,
										params: { id: item.id }
									}"
									>{{ item.binderNumber }}</router-link
								>
							</template>

							<!-- Others -->
							<template v-else>{{ item[column.field] }}</template>
						</template>
					</td>
				</template>
				<template slot="empty">{{ $t("errors.no_data") }}</template>
			</j-data-table>
		</j-card>

		<!-- Pagination -->
		<div class="flex xs-12 p4 xs-center mb15">
			<j-pagination
				:amount="numberOfItems"
				:perPage="itemsPerPage"
				:activePage="page"
				@click="onPageChange($event)"
			/>
		</div>
	</core-layout-content>
</template>

<script>
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import JCard from "@/components/JCard/"
import JDataTable from "@/components/JDataTable/"
import JBaseInputSearch from "@/components/JBaseInputSearch/"
import JPagination from "@/components/JPagination/"
import CorePaginationInfo from "@/modules/core/components/CorePaginationInfo"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import dayjs from "dayjs"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import debounce from "lodash.debounce"

export default {
	components: {
		CrmIcon,
		JButton,
		JCard,
		JDataTable,
		JBaseInputSearch,
		JPagination,
		CorePaginationInfo,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions
	},

	data() {
		return {
			isLoading: false,

			// Actual fetched data
			binders: [],
			numberOfItems: 0,

			// Search term
			searchTerm: null,

			// Pagination
			page: 1,
			itemsPerPage: 30,

			// Header of table
			header: [
				{
					field: "binderNumber",
					text: this.$t("number")
				},
				{
					text: this.$t("created"),
					field: "createdAt"
				}
			]
		}
	},

	computed: {
		/**
		 * Compute fetch data for data table
		 * This is what we are gonna display
		 */
		binders_() {
			return this.binders.map(item => ({
				id: item.id,
				// HACK: get binderNumber fact
				binderNumber: item?.facts?.find(fact => fact.type === "binderNumber")
					?.value?.stringValue,
				createdAt: item.createdAt
					? dayjs(item.createdAt).format(
							this.$store.state.settings.dateTimeFormat
					  )
					: null
			}))
		}
	},

	methods: {
		onPageChange(pageIndex) {
			this.page = pageIndex
			this.fetchBinders()
			this.scrollToTop()
		},

		scrollToTop() {
			this.$scrollTo("body", 300)
		},

		onSearch: debounce(function(value = null) {
			this.searchTerm = value === null || value === "" ? null : value.trim()
			this.page = 1

			this.fetchBinders()
		}, 200),

		cancelSearch() {
			this.searchTerm = null
			this.page = 1
			this.onSearch()
		},

		async fetchBinders() {
			const query = gql`
				query binders(
					$where: binderWhereInput
					$sort: sortInput
					$limit: Int
					$skip: Int
				) {
					binders(where: $where, sort: $sort, limit: $limit, skip: $skip) {
						totalCount
						list {
							bindingDate
							# commissionRule
							createdAt
							endDate
							firstParty {
								name
							}
							facts {
								id
								type
								value {
									stringValue
								}
							}
							id
							name
							# otherIds
							secondParty {
								name
							}
							startDate
							status
						}
					}
				}
			`
			// Sorting - sort by createdAt
			let sort = { fieldName: "createdAt", type: "desc" }

			// Pagination
			const skip = (this.page - 1) * this.itemsPerPage
			const limit = this.itemsPerPage

			// Search
			let where = null
			if (this.searchTerm)
				where = {
					name_contains: this.searchTerm
				}

			this.isLoading = true
			// const res = await api.binders({ sort, skip, limit, where })
			const res = await api({
				query,
				variables: {
					where,
					limit,
					skip,
					sort
				}
			})
			this.isLoading = false

			this.binders = res?.data?.binders?.list || []
			this.numberOfItems = res?.data?.binders?.totalCount || 0
		}
	},

	mounted() {
		this.fetchBinders()
	}
}
</script>
